module.exports = __webpack_public_path__ + "pc/img/award2021_03.2f960600.png";